<template>
  <v-tooltip bottom max-width="300px" color="#4F5779">
    <template v-slot:activator="{ on }">
      <div
        v-on="on"
        :class="{ 'integration-chip--is-disabled': !isEnabled }"
        class="integration-chip"
      >
        <component :is="iconComponents[type]" />
        <IntegrationStatusIndicator
          :type="status.type"
          :is-disabled="!isEnabled"
        />
      </div>
    </template>
    <div class="tooltip-content">
      <div class="tooltip-content__row">
        <div class="tooltip-content__label">
          {{ $t("message.common.status") }}:
        </div>
        <div class="tooltip-content__value">{{ status.name }}</div>
      </div>
      <div class="tooltip-content__row">
        <div class="tooltip-content__label">
          {{ $t("message.common.details") }}:
        </div>
        <div class="tooltip-content__value">{{ tooltipText }}</div>
      </div>
    </div>
  </v-tooltip>
</template>

<script>
import IntegrationStatusIndicator from "@/components/Permissions/IntegrationStatusIndicator.vue";
export default {
  name: "IntegrationChip",
  components: {
    IntegrationStatusIndicator
  },
  props: {
    isEnabled: {
      type: Boolean,
      default: false
    },
    status: {
      type: Object,
      required: true
    },
    tooltipText: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    iconComponents() {
      return {
        google: () => import("@/components/ui/Icons/GoogleMapsIcon.vue"),
        bing: () => import("@/components/ui/Icons/BingIcon.vue"),
        apple: () => import("@/components/ui/Icons/AppleIcon.vue"),
        facebook: () => import("@/components/ui/Icons/FbBlueIcon.vue")
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.integration-chip {
  padding: $spacing;
  border-radius: 30px;
  height: 40px;
  border: 1px solid rgba(54, 60, 86, 0.08);
  display: flex;
  align-items: center;
  gap: $spacing * 0.5;

  &:hover {
    border-color: $primary;
  }

  &--is-disabled {
    filter: grayscale(100%);

    & > * {
      fill-opacity: 0.66;
    }
  }
}
.tooltip-content {
  display: flex;
  flex-direction: column;
  gap: $spacing * 3;

  &__row {
    display: flex;
    gap: $spacing * 2;
    flex-wrap: nowrap;
  }

  &__label {
    width: 75px;
    flex-shrink: 0;
  }
}
</style>
